export const ALL_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const DEFAULT_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const AVAILABLE_KEYWORDS = [
  '#reschedule_link',
  '#appointment_date',
  '#appointment_time',
  '#first_name',
  '#last_name',
  '#full_name',
  '#email_address',
  '#my_email',
  '#my_office_phone_number',
  '#my_forwarding_number',
  '#my_first_name',
  '#my_last_name',
  '#my_full_name',
  '#my_business_website',
  '#my_booking_link',
  '#my_producer_link',
  '#digital_business_card_link',
  '#next_month_full_name',
  '#new_line',
];

export const DURATION_OPTIONS = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];

export const DEFAULT_TITLE = 'Please select a time slot that would best fit your schedule.';
export const DEFAULT_INSTRUCTIONS = 'Appts typically last between 5-10 minutes';
export const DEFAULT_FIELDS = [
  { id: 'field_0', label: 'Beneficiary', required: false },
  { id: 'field_1', label: 'Notes', required: false },
];
export const DEFAULT_CONFIRMATION_TEXT =
  'Hi #first_name, your appointment with #my_first_name is confirmed for #appointment_date at #appointment_time. If you need to reschedule: #reschedule_link';
export const DEFAULT_CONFIRMATION_EMAIL =
  'Hi #first_name,\n\nYour appointment is confirmed for #appointment_date at #appointment_time.\n\nBest regards,\n#my_full_name';

export const DEFAULT_APPEARANCE = {
  backgroundColor: '#FFFFFF',
  fontColor: '#000000',
  slotColor: '#2196f3',
  slotFontColor: '#ffffff',
  slotBorderColor: '#000000',
  slotAppearance: 'filled', // 'filled' = Shadow, 'outlined' = No shadow
};

export const APPEARANCE_COLORS = [
  ['backgroundColor', 'Page background color', '#FFFFFF'],
  ['fontColor', 'Page font color', '#000000'],
  ['slotColor', 'Time slot background color', '#2196f3'],
  ['slotFontColor', 'Time slot font color', '#ffffff'],
  ['slotBorderColor', 'Time slot border color', '#000000'],
];

export const DEFAULT_REMINDER_TEXT = {
  id: 'reminder_1',
  num: 15,
  unit: 'MINUTES',
  text: "Hello #first_name, This is Easton I'm just reaching out with a reminder of our appointment in 15 minutes. Please confirm that this time still works.",
};
